<ng-container *ngIf="columnData.columnType == TOOLTIP_COLUMN">
    <div class="divWidth">
        <span title="{{tooltipColumnText}}"
            class="concat-long-text"
            [innerHtml]="columnValue[columnData.columnName] | highlight : searchTerm">
        </span>
    </div>
</ng-container>

<ng-container *ngIf="columnData.columnType == INDICATOR_ICON_COLUMN">
    <div class="actionability" *ngIf="displayIcon()">
        <div *ngIf="actionable()" class="indicator actionabilityCurated">
          <div class="aberration-warning" title="Curated">
            <span>C</span>
          </div>
        </div>
        <div> </div>
        <div class="indicator {{columnData.className}} {{columnData.className + columnValue[columnData.columnName]}} ">
          <div *ngIf="displayIcon()" class="aberration-warning" title="{{indicatorIconText}}" >
            <span>{{displayValue}}</span>
          </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="columnData.columnType == ICON_COLUMN">
    <div class="divWidth column-icon" title="{{iconColumnTitle}}">
        <span *ngIf="value == 'Germline'" class="icon__TN-germline"></span>
        <span *ngIf="value == 'LOH'" class="icon__TN-low"></span>
        <span *ngIf="value != 'LOH' && value != 'Germline' && value!= 'Somatic'" class="icon__TN-unknown"></span>
        <span  *ngIf="value == 'Somatic'" class="icon__TN-somatic">
            <span class="path1"></span>
            <span class="path2"></span>
        </span>
    </div>

</ng-container>

<ng-container *ngIf="columnData.columnType == COSMIC_COLUMN">
    <span class="divWidth">
        <a target="_blank" title="{{cosmicURL(value)}}" href="{{cosmicURL(value)}}"
           class="extra-detail-val-link">{{value}}
        </a>
    </span>
</ng-container>

<ng-container *ngIf="columnData.columnType == BOOLEAN_COLUMN">
    <span class="divWidth"> {{getValue()}}</span>
</ng-container>

<ng-container *ngIf="columnData.columnType == BASIC_COLUMN">
    <span class="basic-text" genTooltip
          [tooltipText]="columnValue[columnData.columnName]"
          [tooltipPosition]="'BOTTOM'"
          [tooltipShow]="(tooltipEnabled && columnValue[columnData.columnName]?.length > 12)"
          [innerHtml]="columnValue[columnData.columnName] | highlight:searchTerm">
    </span>
</ng-container>